export default __webpack_public_path__ + "static/media/DM.82777648.png";